module.exports = __webpack_public_path__ + "img/m_pbck.6081545e.png";